/**
 * @module businessComponents\sys\tableColumn
 */
import Vue from "vue";
import Component from "vue-class-component";
import { Prop, Watch } from "vue-property-decorator";
import GhTablePage from "@/components/ghTablePage/ghTablePage";
import GhInvoke from "@/components/ghInvoke/ghInvoke";
import BasicProperty from "./templates/basicProperty/basicProperty";
import DynamicProperty from "./templates/dynamicProperty/dynamicProperty";
import { MethodService } from "../../../../utils/serviceModel";

@Component({
  components: {
    BasicProperty,
    DynamicProperty
  }
})
export default class TableColumn extends Vue {
  @Prop({ default: "" })
  private tableId!: string;

  private headers: ITableHeader[] = [
    {
      value: "select",
      text: "选择"
    },
    {
      value: "Db",
      text: "数据库"
    },
    {
      value: "Cd",
      text: "表名"
    },
    {
      value: "Name",
      text: "中文名称"
    },
    {
      value: "Demo",
      text: "备注"
    }
  ];

  private queryTableArgs = {
    db: "",
    keyword: "",
    pagination: {
      rowsPerPage: 5,
      sortBy: "Cd"
    }
  };

  private selectedTables: IndexObject[] = [];

  private get args() {
    if (this.tableId) {
      let args = { tableId: this.tableId };
      return args;
    }
    return null;
  }

  private get TableResult() {
    if (this.svGetTables.data) {
      return this.svGetTables.data;
    } else {
      return [0, []];
    }
  }

  @Watch("args")
  private query() {
    if (this.tableId) {
      this.getTable();
      let table = this.$refs.table as GhTablePage;
      if (this.args) {
        table.query(this.args);
      }
    }
  }

  mounted() {
    this.query();
    this.fetchTables();
  }

  private async getTable() {
    if (this.tableId) {
      let inv = this.$refs.invTable as GhInvoke;
      inv.invoke({ id: this.tableId });
    }
  }

  @Watch("queryTableArgs.pagination", { deep: true })
  private fetchTables() {
    this.svGetTables.invokeAsyn(this.queryTableArgs);
  }

  private beforeSave(item: IndexObject) {
    if (item && this.tableId) {
      item.TableId = this.tableId;
    }
  }

  private async createColumns() {
    if (this.selectedTables.length > 0) {
      let tId = this.selectedTables[0].Id;
      let args = { table_id: this.tableId, template_id: tId };
      this.$setLoading(true);
      try {
        await this.svCreateColumns.invokeAsyn(args);
        this.query();
      } catch (error) {
      } finally {
        this.$setLoading(false);
      }
    }
  }

  private selectTable(props: ITableRowProps) {
    if (props.item) {
      if (props.selected) {
        this.selectedTables = [];
      } else {
        this.selectedTables = [];
        this.selectedTables.push(props.item);
      }
    }
  }

  private svGetTables = new MethodService(
    "plat.db",
    "DataTablesService",
    "query"
  );

  private svCreateColumns = new MethodService(
    "plat.db",
    "ColumnService",
    "create_columns"
  );
}
